import React, { useState } from "react";
import Icon from "../../../components/AppIcon";

const CertificationsSection = () => {
  const [activeTab, setActiveTab] = useState("certifications");

  const certifications = [
    {
      title: "KCAA Remote Pilot License (RPL)",
      issuer: "Kenya Civil Aviation Authority",
      date: "2023",
      validUntil: "2026",
      category: "Visual Production",
      description:
        "Certification for commercial drone operations in Kenya, enabling legal aerial cinematography for corporate clients",
      requirements: [
        "Completed KCAA-approved drone pilot training",
        "Passed KCAA Remote Pilot Knowledge Exam",
        "Background check and security clearance",
        "Compliance with Kenyan airspace regulations",
      ],
      benefits: [
        "Legal commercial drone operations in Kenya",
        "Access to restricted airspace with KCAA authorization",
        "Professional liability coverage",
        "Client confidence in regulatory compliance",
      ],
      image:
        "https://images.unsplash.com/photo-1473968512647-3e447244af8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      icon: "Plane",
    },
    // {
    //   title: "RED Camera Certified Operator",
    //   issuer: "RED Digital Cinema",
    //   date: "2022",
    //   validUntil: "Lifetime",
    //   category: "Visual Production",
    //   description: "Advanced certification in RED camera systems operation, maintenance, and workflow optimization",
    //   requirements: [
    //     "Completed comprehensive RED camera training",
    //     "Demonstrated proficiency in REDCODE workflows",
    //     "Advanced color science understanding",
    //     "Post-production pipeline expertise"
    //   ],
    //   benefits: [
    //     "Optimized camera performance and image quality",
    //     "Efficient workflow and faster turnaround times",
    //     "Access to latest firmware and features",
    //     "Technical support and community resources"
    //   ],
    //   image: "https://images.unsplash.com/photo-1606983340126-99ab4feaa64a?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
    //   icon: "Camera"
    // },
    // {
    //   title: "DaVinci Resolve Certified Colorist",
    //   issuer: "Blackmagic Design",
    //   date: "2023",
    //   validUntil: "Lifetime",
    //   category: "Visual Production",
    //   description: "Professional color grading certification ensuring broadcast-quality color correction and finishing",
    //   requirements: [
    //     "Advanced color theory and practice",
    //     "HDR and wide color gamut workflows",
    //     "Collaborative grading techniques",
    //     "Delivery specifications mastery"
    //   ],
    //   benefits: [
    //     "Professional-grade color grading capabilities",
    //     "Consistent color across all deliverables",
    //     "HDR and cinema-quality finishing",
    //     "Efficient collaborative workflows"
    //   ],
    //   image: "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
    //   icon: "Palette"
    // },
    {
      title: "Moringa School Software Engineering Certification",
      issuer: "Moringa School, Kenya",
      date: "2024",
      validUntil: "Lifetime",
      category: "Website & Digital Presence",
      description:
        "Professional full-stack software engineering certification focusing on web and mobile development, UI/UX, and industry-standard coding practices",
      requirements: [
        "Completed Moringa School full-stack training program",
        "Hands-on projects in front-end and back-end development",
        "Demonstrated understanding of databases, APIs, and frameworks",
        "Practical software deployment and version control",
      ],
      benefits: [
        "Ability to build and maintain dynamic websites and apps",
        "Enhanced technical capacity for client digital solutions",
        "Industry-ready coding and development skills",
        "Confidence in delivering robust digital products",
      ],
      image:
        "https://images.unsplash.com/photo-1555949963-aa79dcee9810?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      icon: "Code",
    },
    // {
    //   title: "Google Digital Marketing & E-commerce Certificate",
    //   issuer: "Google / Coursera",
    //   date: "2023",
    //   validUntil: "Lifetime",
    //   category: "Website & Digital Presence",
    //   description: "Certification covering SEO, social media marketing, e-commerce, and online brand management",
    //   requirements: [
    //     "Completed Google Digital Marketing course",
    //     "Hands-on projects in SEO, SEM, social media, and analytics",
    //     "Assessment completion with passing grades"
    //   ],
    //   benefits: [
    //     "Ability to manage digital campaigns",
    //     "Optimized website and social media presence",
    //     "Improved audience engagement",
    //     "Client-ready skills for digital marketing projects"
    //   ],
    //   image: "https://images.unsplash.com/photo-1581091012184-1f5f0a43cdb7?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
    //   icon: "Globe"
    // },
    // {
    //   title: "Facebook Blueprint Certification",
    //   issuer: "Meta / Facebook",
    //   date: "2023",
    //   validUntil: "Lifetime",
    //   category: "Social Media Presence",
    //   description: "Certification for creating, managing, and optimizing campaigns on Facebook and Instagram for business growth",
    //   requirements: [
    //     "Completed Meta Blueprint training",
    //     "Passed exam covering Ads Manager, campaign optimization, and analytics",
    //     "Demonstrated practical social media marketing skills"
    //   ],
    //   benefits: [
    //     "Optimized social media campaigns",
    //     "Better audience targeting and engagement",
    //     "Credibility for clients seeking social media marketing",
    //     "Data-driven advertising insights"
    //   ],
    //   image: "https://images.unsplash.com/photo-1581091215361-7dff4c63a57f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
    //   icon: "Social"
    // },
    // {
    //   title: "Chartered Institute of Marketing (CIM) Diploma in Professional Marketing",
    //   issuer: "CIM UK / Local Accredited Centers in Kenya",
    //   date: "2023",
    //   validUntil: "Lifetime",
    //   category: "Branding & Promotional Campaigns",
    //   description: "Advanced certification for brand strategy, campaign planning, and integrated marketing execution",
    //   requirements: [
    //     "Completed CIM Diploma training",
    //     "Passed assessments and practical projects",
    //     "Demonstrated marketing strategy and execution skills"
    //   ],
    //   benefits: [
    //     "Ability to deliver professional branding campaigns",
    //     "Enhanced client trust and market credibility",
    //     "Strategic planning for promotional campaigns",
    //     "Integrated multi-channel marketing skills"
    //   ],
    //   image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
    //   icon: "Megaphone"
    // },
    // {
    //   title: "NEBOSH International General Certificate in Occupational Health and Safety",
    //   issuer: "NEBOSH / Accredited Training Centers in Kenya",
    //   date: "2023",
    //   validUntil: "2026",
    //   category: "Safety & Production Management",
    //   description: "Health and safety certification recognized in Kenya ensuring safe production environments",
    //   requirements: [
    //     "Completed NEBOSH-approved training",
    //     "Passed written and practical assessments",
    //     "Hazard identification and risk management",
    //     "Emergency response procedures"
    //   ],
    //   benefits: [
    //     "Safe working environment for all crew",
    //     "Compliance with Kenyan occupational safety regulations",
    //     "Reduced liability and insurance costs",
    //     "Professional risk management"
    //   ],
    //   image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
    //   icon: "Shield"
    // }
  ];

  const insurance = [
    {
      type: "General Liability",
      coverage: "KES 20,000,000",
      description:
        "Comprehensive coverage for third-party injury, property damage, and client protection in Kenya",
      icon: "Shield",
    },
    {
      type: "Equipment Coverage",
      coverage: "KES 5,000,000",
      description:
        "Full replacement value for all professional cameras, drones, and AV equipment used in production",
      icon: "Camera",
    },
    {
      type: "Professional Indemnity (Errors & Omissions)",
      coverage: "KES 10,000,000",
      description:
        "Professional liability coverage protecting against claims from service delivery errors or omissions",
      icon: "FileText",
    },
    {
      type: "Drone Insurance",
      coverage: "KES 10,000,000",
      description:
        "Specialized coverage for commercial drone operations, including aerial cinematography and property protection",
      icon: "Plane",
    },
    {
      type: "Event Production Liability",
      coverage: "KES 15,000,000",
      description:
        "Optional coverage for accidents, damages, or incidents occurring during events or production shoots",
      icon: "Calendar",
    },
    {
      type: "Work Injury Benefits Act (WIBA)",
      coverage: "KES 10,000,000",
      description:
        "Mandatory insurance protecting staff and crew against work-related injuries, in compliance with Kenyan labor law",
      icon: "Users",
    },
  ];

  const memberships = [
    {
      organization: "Kenya Film Commission (KFC)",
      role: "Registered Member",
      since: "2018",
      benefits: [
        "Industry networking in Kenya",
        "Access to film and media resources",
        "Regulatory guidance for productions",
        "Support for local projects and funding",
      ],
      icon: "Film",
    },
    {
      organization: "Kenya Institute of Marketing (KIM)",
      role: "Professional Member",
      since: "2019",
      benefits: [
        "Marketing industry insights",
        "Professional development workshops",
        "Networking with corporate clients",
        "Access to branding and advertising resources",
      ],
      icon: "Users",
    },
    {
      organization: "Kenya Association of Professional Photographers (KAPP)",
      role: "Certified Member",
      since: "2017",
      benefits: [
        "Photography and cinematography standards",
        "Technical workshops and certifications",
        "Networking with creative professionals",
        "Equipment support and discounts",
      ],
      icon: "Camera",
    },
    {
      organization: "Kenya Unmanned Aircraft Systems (KUAS)",
      role: "Registered Operator",
      since: "2020",
      benefits: [
        "Drone operations regulations in Kenya",
        "Safety and compliance training",
        "Technology updates and insights",
        "Networking with other operators",
      ],
      icon: "Plane",
    },
    {
      organization: "Digital Marketing Institute Kenya (DMI-K)",
      role: "Member",
      since: "2021",
      benefits: [
        "Digital marketing and social media strategies",
        "Access to online tools and certifications",
        "Workshops for website, branding, and campaigns",
        "Networking with regional marketers",
      ],
      icon: "Globe",
    },
    {
      organization: "Kenya Association of Event Producers (KAEP)",
      role: "Affiliate Member",
      since: "2022",
      benefits: [
        "Event management best practices",
        "Access to industry suppliers",
        "Professional networking",
        "Guidelines for safe and compliant productions",
      ],
      icon: "Calendar",
    },
  ];

  const tabs = [
    { id: "certifications", label: "Certifications", icon: "Award" },
    // { id: "insurance", label: "Insurance", icon: "Shield" },
    // { id: "memberships", label: "Memberships", icon: "Users" },
  ];

  return (
    <div className="space-y-4 sm:space-y-8 lg:space-y-12">
      {/* Section Header */}
      <div className="text-center max-w-3xl mx-auto">
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-primary mb-2 sm:mb-4">
          Certifications & <span className="text-red-600">Credentials</span>
        </h2>
        <p className="text-lg sm:text-xl text-text-secondary">
          Professional certifications, comprehensive insurance coverage, and
          industry memberships that ensure the highest standards of quality,
          safety, and reliability.
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="flex justify-center">
        <div className="flex bg-surface rounded-xl p-1">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center space-x-1 sm:space-x-2 px-1 sm:px-4 py-2 rounded-xl font-semibold cinematic-transition ${
                activeTab === tab.id
                  ? "bg-accent text-white shadow-subtle"
                  : "text-text-primary hover:text-accent"
              }`}
            >
              <Icon
                name={tab.icon}
                size={20}
                strokeWidth={2}
                className="hidden sm:block"
              />
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {activeTab === "certifications" && (
        <div className="space-y-8">
          <div className="grid lg:grid-cols-2 gap-4 sm:gap-8">
            {certifications.map((cert, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-subtle overflow-hidden hover-lift"
              >
                <div className="p-4 sm:p-6 border-b border-border">
                  <div className="flex items-start space-x-1 sm:space-x-4">
                    <div className="w-16 h-16 shadow-subtle text-red-600 rounded-xl hidden sm:flex items-center justify-center flex-shrink-0">
                      <Icon name={cert.icon} size={24} strokeWidth={2} />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center space-x-1  mb-2">
                        <span className="px-1 sm:px-3 py-1 bg-accent/5 text-accent text-xs font-semibold shadow-subtle rounded-full">
                          {cert.category}
                        </span>
                        <span className="text-sm text-text-secondary">
                          Valid until {cert.validUntil}
                        </span>
                      </div>
                      <h3 className="text-lg font-bold text-primary mb-2">
                        {cert.title}
                      </h3>
                      <p className="text-sm text-text-secondary mb-2">
                        {cert.issuer}
                      </p>
                      <p className="text-sm text-text-secondary">
                        {cert.description}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="p-6 space-y-6">
                  <div>
                    <h4 className="font-semibold  text-red-600 mb-3 flex items-center space-x-2">
                      <Icon name="CheckCircle" size={16} strokeWidth={2} />
                      <span>Requirements Met</span>
                    </h4>
                    <ul className="space-y-1">
                      {cert.requirements.map((req, idx) => (
                        <li
                          key={idx}
                          className="flex items-start space-x-2 text-sm text-text-secondary"
                        >
                          <Icon
                            name="ArrowRight"
                            size={14}
                            strokeWidth={2}
                            className="mt-0.5 flex-shrink-0 text-red-600"
                          />
                          <span>{req}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div>
                    <h4 className="font-semibold text-red-600 mb-3 flex items-center space-x-2">
                      <Icon name="Star" size={16} strokeWidth={2} />
                      <span>Client Benefits</span>
                    </h4>
                    <ul className="space-y-1">
                      {cert.benefits.map((benefit, idx) => (
                        <li
                          key={idx}
                          className="flex items-start space-x-2 text-sm text-text-secondary"
                        >
                          <Icon
                            name="ArrowRight"
                            size={14}
                            strokeWidth={2}
                            className="mt-0.5 flex-shrink-0 text-red-600"
                          />
                          <span>{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* {activeTab === "insurance" && (
        <div className="space-y-8  lg:space-y-8">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="text-xl sm:text-2xl font-bold mb-2 sm:mb-4">
              Comprehensive Insurance{" "}
              <span className="text-red-600">Coverage</span>{" "}
            </h2>
            <p className="text-base text-text-secondary">
              Full insurance protection ensuring peace of mind for every
              project, from equipment coverage to professional liability.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {insurance.map((policy, index) => (
              <div
                key={index}
                className="bg-white p-3 sm:p-6 rounded-xl shadow-subtle hover-lift"
              >
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 shadow-subtle text-red-600 rounded-xl hidden sm:flex items-center justify-center flex-shrink-0">
                    <Icon name={policy.icon} size={20} strokeWidth={2} />
                  </div>
                  <div>
                    <h4 className="font-bold text-primary mb-2">
                      {policy.type}
                    </h4>
                    <p className="text-xl sm:text-2xl font-bold text-accent mb-2">
                      {policy.coverage}
                    </p>
                    <p className="text-sm text-text-secondary">
                      {policy.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-surface rounded-xl p-4 sm:p-6 text-center">
            <Icon
              name="Shield"
              size={48}
              className="mx-auto mb-4  text-red-600"
              strokeWidth={1.5}
            />
            <h2 className="text-xl font-bold text-primary mb-2 sm:mb-4">
              Complete Protection
            </h2>
            <p className="text-text-secondary text-base max-w-2xl mx-auto">
              Our comprehensive insurance coverage protects both our team and
              our clients, ensuring that every project proceeds with confidence
              and security. All policies are maintained with A-rated insurance
              providers and updated annually.
            </p>
          </div>
        </div>
      )}

      {activeTab === "memberships" && (
        <div className="space-y-8 lg:space-y-8">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="text-xl sm:text-2xl font-bold mb-2 sm:mb-4">
              <span className="text-red-600">Professional</span>{" "} Memberships
            </h2>
            <p className="text-base text-text-secondary">
              Active participation in industry organizations keeps us connected
              to the latest trends, technologies, and best practices in
              cinematography and video production.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-6">
            {memberships.map((membership, index) => (
              <div
                key={index}
                className="bg-white p-3 sm:p-6 rounded-xl shadow-subtle hover-lift"
              >
                <div className="flex items-start space-x-4 mb-4">
                  <div className="w-12 h-12 shadow-subtle text-red-600 rounded-xl hidden sm:flex items-center justify-center flex-shrink-0">
                    <Icon name={membership.icon} size={20} strokeWidth={2} />
                  </div>
                  <div>
                    <h4 className="font-bold text-primary mb-1">
                      {membership.organization}
                    </h4>
                    <p className="text-sm text-accent font-semibold mb-1">
                      {membership.role}
                    </p>
                    <p className="text-xs text-text-secondary">
                      Member since {membership.since}
                    </p>
                  </div>
                </div>

                <div>
                  <h5 className="font-semibold text-primary mb-3 text-sm">
                    Membership Benefits
                  </h5>
                  <ul className="space-y-1">
                    {membership.benefits.map((benefit, idx) => (
                      <li
                        key={idx}
                        className="flex items-center space-x-2 text-sm text-text-secondary"
                      >
                        <Icon
                          name="CheckCircle"
                          size={14}
                          className="text-red-600"
                          strokeWidth={2}
                        />
                        <span>{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-black-red-oscillate text-white rounded-xl p-4 sm:p-6 text-center">
            <Icon
              name="Network"
              size={48}
              className="mx-auto text-red-600 mb-4"
              strokeWidth={1.5}
            />
            <h4 className="text-xl text-white font-bold mb-4">Industry Connection</h4>
            <p className="text-white/90 text-sm sm:text-base max-w-2xl mx-auto">
              "Staying connected to the professional community isn't just about
              networking—it's about continuous learning, sharing knowledge, and
              pushing the entire industry forward. These memberships keep us at
              the forefront of cinematography innovation."
            </p>
          </div>
        </div>
      )} */}

      {/* Trust Indicators */}
      <div  className=" rounded-2xl p-8 md:p-12">
        <h3 className="text-3xl font-bold text-primary mb-8 text-center">
          Why <span className="text-red-600">Credentials</span> Matter
        </h3>
        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center shadow-subtle p-4 rounded-3xl space-y-4">
            <div className="w-16 h-16 shadow-subtle rounded-full flex items-center justify-center mx-auto">
              <Icon name="Award" size={24} strokeWidth={2} />
            </div>
            <h4 className="font-bold text-primary">Professional Standards</h4>
            <p className="text-text-secondary text-sm">
              Certifications ensure we meet the highest industry standards for
              quality and safety
            </p>
          </div>
          <div className="text-center shadow-subtle p-4 rounded-3xl space-y-4">
            <div className="w-16 h-16 shadow-subtle rounded-full flex items-center justify-center mx-auto">
              <Icon name="Shield" size={24} strokeWidth={2} />
            </div>
            <h4 className="font-bold text-primary">Risk Management</h4>
            <p className="text-text-secondary text-sm">
              Comprehensive insurance and safety training protect all
              stakeholders
            </p>
          </div>
          <div className="text-center shadow-subtle p-4 rounded-3xl space-y-4">
            <div className="w-16 h-16 shadow-subtle rounded-full flex items-center justify-center mx-auto">
              <Icon name="TrendingUp" size={24} strokeWidth={2} />
            </div>
            <h4 className="font-bold text-primary">Continuous Growth</h4>
            <p className="text-text-secondary text-sm">
              Ongoing education and industry involvement keep us ahead of trends
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificationsSection;
